import { useState } from 'react';
import { AiHero } from './components/AiHero';
import { AiPromptList } from './components/AiPromptList';
import { AiLoader } from './components/AiLoader';
import GeneratedImage from "../../../imports/GeneratedImage";

function FloatingArrow() {
  return (
    <div className="absolute bg-white content-stretch flex items-center left-[calc(91.67%+83px)] p-[6px] rounded-[16px] size-[32px] top-[507px] cursor-pointer shadow-sm z-20">
      <div aria-hidden="true" className="absolute border border-[#d0d5dd] border-solid inset-0 pointer-events-none rounded-[16px]" />
      <div className="flex items-center justify-center relative shrink-0 size-[20px]">
        <div className="flex-none rotate-[270deg]">
          <div className="relative size-[20px]">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
              <g id="Dropdown">
                <path d="M5 7.5L10 12.5L15 7.5" id="Icon" stroke="#1D2739" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

const AiGeneratorPage = () => {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success'>('idle');
  const [_prompt, setPrompt] = useState('');

  const handleGenerate = (newPrompt: string) => {
    if (!newPrompt.trim()) return;
    setPrompt(newPrompt);
    setStatus('loading');

    // Simulate AI generation delay (8-10 seconds)
    setTimeout(() => {
      setStatus('success');
    }, 9000);
  };

  if (status === 'success') {
    return (
      <div className="bg-white relative w-full min-h-screen overflow-x-hidden font-sans">
        <div className="w-full h-full min-h-screen">
          <GeneratedImage onHomeClick={() => setStatus('idle')} />
        </div>
        {/* Optional: Add a back button or reset button if needed, but the design didn't specify one */}
      </div>
    );
  }

  return (
    <div className="relative w-full size-full font-sans">
      {status === 'loading' && <AiLoader />}

      <div className="flex flex-col gap-[32px] items-start relative shrink-0 w-full">
        <AiHero onGenerate={handleGenerate} />
        <AiPromptList />
      </div>
      <FloatingArrow />
    </div>
  );
}

export default AiGeneratorPage;

